__turbopack_context__.v({
  "check-row": "LF4yXW_check-row",
  "config-fields": "LF4yXW_config-fields",
  "configuration": "LF4yXW_configuration",
  "field-hint": "LF4yXW_field-hint",
  "field-label": "LF4yXW_field-label",
  "generate-button": "LF4yXW_generate-button",
  "panel-description": "LF4yXW_panel-description",
  "panel-heading": "LF4yXW_panel-heading",
  "period-note": "LF4yXW_period-note",
  "selection-list": "LF4yXW_selection-list",
});
